function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import Button from 'components/Form/Button';
import { useAction } from 'hooks';
import App from 'modules/App';
import styles from 'modules/Layout/components/MainLayout/MainLayout.pcss';
import messages from 'modules/Layout/messages';
import PatientResults from 'modules/PatientResults';
const ClosePrintModeBtn = ()=>{
    const isPrintMode = useSelector(App.selectors.printMode);
    const setDashboardLayout = useAction(PatientResults.actions.setDashboardLayout, PatientResults.constants.DASHBOARD_LAYOUTS.bgm);
    const setPrintMode = useAction(App.actions.setPrintMode, false);
    if (!isPrintMode) {
        return null;
    }
    const onCloseReport = ()=>{
        setDashboardLayout();
        setPrintMode();
    };
    return /*#__PURE__*/ _jsx(Button, {
        type: "button",
        styleModifier: "secondary",
        className: cn('btn--filled', styles.closePrintModeBtn),
        onClick: onCloseReport,
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.printMode.closePrintMode))
    });
};
export default ClosePrintModeBtn;
